import { makeStyles } from '@soil-capital/ui-kit/style';

export const useCoverCropDestructionDateStyles = makeStyles()((theme) => ({
    timeOnField: {
        marginTop: `-${theme.spacing(3)}`,
    },
}));
